var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "h-8 rounded-lg bg-gray-100 flex items-center relative pointer-events-auto",
    },
    [
      _c("input", {
        ref: "search",
        staticClass:
          "w-full h-full border-none pr-8 pl-4 bg-transparent text-sm",
        attrs: { placeholder: _vm.$t("common.search") },
        domProps: { value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event.target.value)
          },
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            return _vm.$emit("clear")
          },
        },
      }),
      _c("GrmResetBtn", {
        staticClass: "absolute right-1",
        on: {
          click: function ($event) {
            return _vm.$emit("clear")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }